export const SET_ANALYTICS_ID = 'SET_ANALYTICS_ID';
export const TRACK_EVENT = 'TRACK_EVENT';
export const ANALYTICS_SET_PEOPLE_PROPS = 'ANALYTICS_SET_PEOPLE_PROPS';
export const ANALYTICS_SET_MANDATORY_PEOPLE_PROPS = 'ANALYTICS_SET_MANDATORY_PEOPLE_PROPS';
export const ANALYTICS_REGISTER_MANDATORY_SUPER_PROPS = 'ANALYTICS_REGISTER_MANDATORY_SUPER_PROPS';

export const setAnalyticsId = (analyticsId) => ({ type: SET_ANALYTICS_ID, analyticsId });
export const registerAnalyticsMandatorySuperProps = (props) => ({ type: ANALYTICS_REGISTER_MANDATORY_SUPER_PROPS, props: { ...props }});
export const setAnalyticsPeopleProps = (props) => ({ type: ANALYTICS_SET_PEOPLE_PROPS, props: { ...props }});
export const setAnalyticsMandatoryPeopleProps = (props) => ({ type: ANALYTICS_SET_MANDATORY_PEOPLE_PROPS, props: { ...props }});
export const trackEvent = (event, prefix) => ({ type: TRACK_EVENT, event, prefix });
